module.exports = "<p class=\"no-access\">\n  Access Denied\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/no-access/no-access.component.html
// module id = ./src/app/shared/components/no-access/no-access.component.html
// module chunks = main